<template >
    <!-- 内容 -->
    <v-content class="home">
      <!-- 分类标题  -->
      <div class="white title">
        <div class="mx-auto py-0 d-flex titleBox">
          <div class="red text-center white--text body-2 titleType"> 全部分类</div>
          <div class=" text-center red--text subtitle-2 font-weight-medium titleHome"  @click="logoToHome"> 首页</div>
          <div class=" text-center black--text subtitle-2 font-weight-medium titleList"  @click="pageToCg"> 常购清单</div>
        </div>
      </div>
      <!-- 菜单/轮播/个人信息 -->
      <div class="mx-auto py-0 d-flex w12">
        <div class="bannerLeft">
          <v-list flat list-item-min-heigh="20px" dense class="pa-0 overflow-y-auto" height="500px">
            <v-list-item-group v-model="item">
              <v-list-item v-for="(item, i) in userTypeList" :key="i" class="pa-0 text-center">
                <v-menu open-on-hover offset-x transition="slide-x-transition">
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }">
                      <v-list-item-content  v-on="on" class="pa-3" :class="hover?'red--text red lighten-5':null">
                        <v-list-item-title v-text="item.label" ></v-list-item-title>
                        <div class="xian"><v-divider></v-divider></div>
                      </v-list-item-content>
                    </v-hover>
                  </template>
                  <v-card class="red lighten-5 typeList" outlined tile>
                    <v-container pa-3 class="red lighten-5" >
                      <v-row no-gutters>
                        <v-col v-for="(item, index) in item.children" :key="index" @click="goList(item)" cols="12" sm="2">
                          <kbd class="float-left caption px-1 text-center text-truncate" style="cursor: pointer; width: 120px;color:#141414;background:none;"> {{ item.label }} </kbd>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-menu>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <div style="width:750px;"><v-carousel cycle hide-delimiter-background hide-delimiters show-arrows-on-hover>
            <template v-if="bannerPhotos && bannerPhotos.length">
<!--         link to=""     toList(item.id)-->
              <v-carousel-item v-for="(item,i) in bannerPhotos" :key= "i" :src="imageUrl+item.bannerImageUrl" @click="toList(item.id)"></v-carousel-item>
            </template>
            <template v-else>
              <v-carousel-item src="@/assets/img/kongtupian.png"></v-carousel-item>
            </template>
          </v-carousel></div>
        <div class="bannerRight">
          <v-card class="mx-auto mt-5 bannerRightCard" width="200" height="220" @click="personalCenter()">
            <v-card-text class="text-center">
              <v-avatar class="mt-6" color="grey lighten-2" size="72">
                <v-img v-if="imageBealer" src='@/assets/img/morentouxiang@2x.png'></v-img>
                <v-img v-if="!imageBealer" :src='userMessage.userImageUrl'></v-img>
              </v-avatar>
              <div class="mt-2 text-truncate" style="color:#141414;">{{ userMessage.userName }}</div>
              <p class="red--text mt-5">嗨，欢迎登录菜乐购！</p>
            </v-card-text>
          </v-card>
        </div>
      </div>
      <!--快捷入口-->
      <div class="mx-auto py-0 d-flex mt-1 quickAccess" >
        <div class="d-flex justify-space-around quickAccessBox"  style="width: 100%; max-height: 145px;background: white;cursor: pointer; padding:17px 0;" >
          <div v-for="(item,i) in kuaijie" :key="i" @click="goAccess(item)">
            <div style="width: 96px;height: 96px;border-radius: 48px;overflow: hidden;"> <v-img width="100%" height="100%" :src="imageUrl+item.icon"></v-img></div>
            <p class="text-center subtitle-2" style="margin-top: 6px;">{{ item.firstEntryName}}</p>
          </div>
        </div>
      </div>
      <!--促销活动（一个）-->
      <div v-for="(event,index) in eventList" :key="index">
        <div v-if="event.eventEntityVOS.length === 1">
          <div class="mx-auto mt-5 w12 oneAccess" v-show="oneEvent" style="cursor: pointer;" v-for="(item, index) in event.eventEntityVOS" :key="index" >
            <div class="oneOver" v-if="nowTime > Date.parse(item.endTime)||item.endTime==null||item.status==40||item.status==50||item.status==10"><v-img class="oneOverImg" width="148px" height="84px" src="@/assets/img/yijieshu.png"></v-img></div>
            <!--标题-->
            <div class="d-flex align-center justify-space-between px-5 white accessTtile">
              <blockquote @click="pageToPromotion(item.eventId)">
                <div class="d-inline title" >{{item.eventName}}</div>
                <div class="d-inline body-2 grey--text text--darken-1 ml-1">{{item.describe}}</div>
              </blockquote >
              <!-- 倒计时   v-if="item."-->
              <div v-if="item.countTime === 0">
                <blockquote v-if="Date.parse(item.startTime)>nowTime"><div class="timing"><span class="mr-3"><span>距活动开始：</span>{{item.times && item.times.day}}天</span><span class="mr-1 titixt">{{item.times && item.times.hour}}</span><span class="dot">:</span><span class="mr-1 titixt">{{item.times && item.times.min}}</span><span class="dot">:</span><span class="titixt">{{item.times && item.times.second}}</span></div></blockquote >
                <blockquote v-else-if="Date.parse(item.endTime)<nowTime ||item.status==40"><div class="timing"><span class="mr-3">活动已结束</span></div></blockquote >
                <blockquote v-else><div class="timing"><span class="mr-3"><span>距活动结束：</span>{{item.times && item.times.day}}天</span><span class="mr-1 titixt">{{item.times && item.times.hour}}</span><span class="dot">:</span><span class="mr-1 titixt">{{item.times && item.times.min}}</span><span class="dot">:</span><span class="titixt">{{item.times && item.times.second}}</span></div></blockquote >
              </div>
            </div>
            <div class="d-flex accessCont" >
              <div class="white accessContLeft" @click="pageToPromotion(item.eventId)"><v-img :src="imageUrl+item.imageUrl" height="100%"></v-img></div>
              <div class="white accessContRight" @click="navToGoodsDetail(item.oneShopList.ssuCode)">
                <div class="font-weight-bold shopName ml9">{{item.oneShopList && item.oneShopList.shopName }}</div>
                <div class="tips text-truncate"><span style="color:#E51C23;">{{item.oneShopList && item.oneShopList.skuAlias}}</span>  {{ item.oneShopList && item.oneShopList.skuSpecDescList.join(',')}}</div>
                <div class="text-center d-flex zw"><div class="accessBorder" v-for="(items, ind) in item.oneShopNameList" :key="ind">{{ item.oneShopList && items.promotion }}</div></div>
                <!--            <div class="text-center d-flex mb-1 zw">-->
                <!--              <div v-show="isShow" class="accessBorder mr-1" >{{ item.oneShopList && item.oneShopList[0].promotion }}</div>-->
                <!--              <div style="color:#B71210;font-size: 12px;line-height: 19px;" class="mr-1 cp"  @click="navToGoodsDetail(item.oneShopList[0].ssuCode[0].ssuCode)">{{item.oneShopList[0].ssuCode[0].ssuName}}</div>-->
                <!--            </div>-->
                <div class="shopPrice"><span class="smallSize" > {{item.oneShopList ?'￥': ''}}</span>{{item.oneShopList && item.oneShopList.price}}</div>
                <v-img class="float-right" width="157" height="157 " v-if="item.oneShopList && item.oneShopList.imgUrl" :src="imageUrl+item.oneShopList.imgUrl"></v-img>
              </div>
            </div>
          </div>
        </div>
        <div v-if="event.eventEntityVOS.length === 2">
          <!--促销活动（二个）-->
          <div class="mx-auto mt-5 d-flex justify-space-between accessTwo">
            <v-container class="white accessBox" v-for="(tl,t) in event.eventEntityVOS" :key="t">
              <div class="twoOver" v-if="nowTime > Date.parse(tl.endTime)||Date.parse(tl.endTime)===null||tl.status===40||tl.status===50||tl.status===10"><v-img class="twoOverImg" width="148px" height="84px" src="@/assets/img/yijieshu.png"></v-img> </div>
              <div class="d-flex align-center justify-space-between white accessTwoTitle">
                <blockquote @click="pageToPromotion(tl.eventId)">
                  <div class="d-inline title" >{{tl.eventName}}</div>
                  <div class="d-inline body-2 grey--text text--darken-1 ml-1">{{tl.describe}}</div>
                </blockquote >
                <!-- 倒计时-->
                <div v-if="tl.countTime === 0">
                  <blockquote v-if="Date.parse(tl.startTime)>nowTime">
                    <div class="timing">
              <span class="mr-3">
                <span>距活动开始：</span>{{tl.times && tl.times.day}}天</span>
                      <span class="mr-1 titixt">{{tl.times && tl.times.hour}}</span>
                      <span class="dot">:</span>
                      <span class="mr-1 titixt">{{tl.times && tl.times.min}}</span>
                      <span class="dot">:</span>
                      <span class="titixt">{{tl.times && tl.times.second}}</span>
                    </div>
                  </blockquote >
                  <blockquote v-else-if="Date.parse(tl.endTime)<nowTime ||tl.status==40">
                    <div class="timing">
                      <span class="mr-3">活动已结束</span>
                    </div>
                  </blockquote >
                  <blockquote v-else>
                    <div class="timing">
              <span class="mr-3">
                <span>距活动结束：</span>{{tl.times && tl.times.day}}天</span>
                      <span class="mr-1 titixt">{{tl.times && tl.times.hour}}</span>
                      <span class="dot">:</span>
                      <span class="mr-1 titixt">{{tl.times && tl.times.min}}</span>
                      <span class="dot">:</span>
                      <span class="titixt">{{tl.times && tl.times.second}}</span>
                    </div>
                  </blockquote >
                </div>
              </div>
              <div>
                <v-img @click="pageToPromotion(tl.eventId)" width="545" height="273" :src="imageUrl+tl.imageUrl"></v-img>
              </div>
              <blockquote style="height: 146px;" class="d-flex d-flex align-center">
                <div ><v-img @click="navToGoodsDetail(tl.twoShopList.ssuCode)" width="112px" height="112px" v-if="tl.twoShopList && tl.twoShopList.imgUrl" :src="imageUrl+tl.twoShopList.imgUrl"></v-img></div>
                <div style="margin-left: 15px;">
                  <div class="font-weight-bold shopName ml9" @click="navToGoodsDetail(tl.twoShopList.ssuCode)">{{tl.twoShopList && tl.twoShopList.shopName}}</div>
                  <div class="tips text-truncate"><span style="color:#E51C23;">{{tl.twoShopList && tl.twoShopList.skuAlias}}</span>  {{ tl.twoShopList && tl.twoShopList.skuSpecDescList.join(',')}}</div>
                  <!--              <div class="text-center d-flex mb-1 zw">-->
                  <!--                <div v-show="isShow" class="accessBorder mr-1" >{{tl.twoShopNameList[0].promotion}}</div>-->
                  <!--                <div style="color:#B71210;font-size: 12px;line-height: 19px;" class="mr-1 cp"  @click="navToGoodsDetail(tl.twoShopNameList[0].ssuCode[0].ssuCode)">{{ tl.twoShopNameList[0].ssuCode[0].ssuName }}</div>-->
                  <!--              </div>-->
                  <div class="text-center d-flex mb-1 zw" v-for="(items, ind) in tl.twoShopNameList" :key="ind">
                    <div v-show="isShow" class="accessBorder mr-1" >{{ tl.twoShopList && items.promotion }}</div>
                    <div style="color:#B71210;font-size: 12px;line-height: 19px;" class="mr-1 cp" v-for="(n, k) in items.ssuCode" :key="k" @click="navToGoodsDetail(n.ssuCode)">{{n.ssuName}}</div>
                  </div>
                  <div class="shopPrice"><span class="smallSize"> {{tl.twoShopList ?'￥': ''}}</span>{{tl.twoShopList && tl.twoShopList.price}}</div>
                </div>
              </blockquote>
            </v-container>
          </div>
        </div>
        <!--促销活动（三个）-->
        <div v-if="event.eventEntityVOS.length === 3">
          <div class="mx-auto mt-5 d-flex justify-space-between accessThree" v-show="threeEvent" v-for="thList in threeEventList" :key="thList.eventId">
            <v-container class="white accessThreeTitle" v-for="(thl, h) in threeList" :key="h">
              <blockquote class="accessTwoTitle" >
                <div class="d-inline title" @click="pageToPromotion(thl.eventId)">{{thl.eventName}}</div>
                <div class="d-inline body-2 grey--text text--darken-1 ml-1">{{thl.describe}}</div>
              </blockquote >
              <div class="shopImg">
                <div v-if="nowTime> Date.parse(thl.endTime)||thl.endTime==null||thl.status==40||thl.status==50||thl.status==10" class="over"><v-img class="overImg" width="148px" height="84px" src="@/assets/img/yijieshu.png"></v-img> </div>
                <v-img @click="pageToPromotion(thl.eventId)" width="340px" height="340px" :src="imageUrl+thl.imageUrl"></v-img>
              </div>
            </v-container>
          </div>
        </div>
      </div>
      <!--通栏广告-->
<!--      <div style=" height: 272px;" class="mx-auto cyan mt-5 w12 cp" v-for="item in advertisementList" :key="item.id" >-->
<!--        <v-img @click="toList(item.id)" v-ripple height="100%" :src="imageUrl+item.bannerImageUrl"></v-img>-->
<!--      </div>-->
      <div style="width: 1200px;padding:20px;" class="mx-auto white mt-5 w12 cp d-flex justify-space-between flex-wrap" v-if="advertisementList.length>0">
        <div class="mb-2" style="width: 49%;height: 133px; overflow: hidden;" v-for="item in advertisementList" :key="item.id" > <v-img @click="toList(item.id)" v-ripple width="100%" height="100%" :src="imageUrl+item.bannerImageUrl"></v-img> </div>
        <div class="mb-2" style="width: 49%;height: 133px; overflow: hidden;" v-if="advertisementList.length/2 % 1" >
<!--          <div class="d-flex align-center justify-center" style="width: 100%;height: 133px;background:rgba(120,2,2,.4);color: white;">敬请期待...</div>-->
          <v-img v-ripple width="100%" height="100%" src="@/assets/img/more.png"></v-img>
        </div>
      </div>
      <!--新品上架 热销榜-->
      <div style="width:1200px;" class="d-flex justify-space-between mx-auto mt-5">
        <div style="width: 590px;height: 732px" class="red lighten-5">
          <div class="px-4 d-flex align-center" style="width:100%;height:88px;background:linear-gradient(87deg,rgba(217,63,55,1) 0%,rgba(255,77,68,1) 100%);">
            <div class="white--text title" style="line-height: 48px;">新品上架</div>
            <div class="white--text body-2 text-center" @click="viewMorenew()" style="width:83px;height:32px;border:1px solid rgba(230,230,230,1);line-height:32px; cursor:pointer;">查看更多</div>
          </div>
          <div class=" mt-5 px-5" style="width:100%;height:615px;">
            <v-card width="100%" height="100%" tile elevation="0" color="red lighten-5">
              <v-carousel class="redLeft" cycle :show-arrows="false" hide-delimiter-background delimiter-icon="mdi-circle" height="100%" interval="4000">
                <v-carousel-item  v-for="i in parseIntNum" :key="i">
                  <div v-for="(slide, k) in newTopList" :key="k">
                    <v-card v-if="(k + 1) <= (i * 4) && Math.ceil((k+1) / 4) == i" max-width="100%" height="146" light tile class="d-flex align-center px-5 mb2" elevation="0" @click="navToGoodsDetail(slide.ssuList[0].ssuCode)">
                      <div><v-img :src="imageUrl+slide.skuImgMain" height="112px" width="112px" ></v-img></div>
                      <div style="margin-left: 15px;">
                        <div class="font-weight-bold shopName" style="margin-left: 9px;">
                          <template v-if="slide.ssuList.length > 1">
                            <b v-if="slide.hdActive" style="color: #B71210;">【活动】</b>
                          </template>
                          <template v-else>
                            <b v-if="slide.ssuList[0].eventMark === 10" style="color: #B71210;">【满送】</b>
                            <b v-if="slide.ssuList[0].eventMark === 20" style="color: #B71210;">【满赠】</b>
                            <b v-if="slide.ssuList[0].eventMark === 30" style="color: #B71210;">【满减】</b>
                            <b v-if="slide.ssuList[0].eventMark === 40" style="color: #B71210;">【折减】</b>
                            <b v-if="slide.ssuList[0].eventMark === 50" style="color: #B71210;">【特价】</b>
                          </template>
                          {{slide.ssuSkuName}}
                        </div>
                        <div class="tips"><span style="color:#E51C23;">{{slide.skuAlias}}</span>  {{ slide.skuSpecDescList.join('，') }}</div>
                        <div class="text-center d-flex zw"></div>
                        <div class="shopPrice">
<!--                          <span class="smallSize"> &yen;</span>-->
                          {{ slide.price }}
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </div>
        </div>
        <div style="width: 590px;height: 732px" class="blue lighten-5">
          <div  class="px-4 d-flex align-center" style="width:590px;height:88px;background:linear-gradient(90deg,rgba(57,108,236,1) 0%,rgba(88,171,249,1) 100%);">
            <div class="white--text title" style="line-height: 48px;">热销榜</div>
            <div class="white--text body-2 text-center" @click="viewMoretop()" style="width:83px;height:32px;border:1px solid rgba(230,230,230,1);line-height:32px; cursor:pointer;">查看更多</div>
          </div>
          <div class=" mt-5 px-5" style="width:100%;height:615px;">
            <v-card width="100%" height="100%" tile elevation="0" color="blue lighten-5">
              <v-carousel class="blueRight" cycle :show-arrows="false" hide-delimiter-background delimiter-icon="mdi-circle" height="100%" interval="4000">
                <v-carousel-item  v-for="i in parseTopNum" :key="i">
                  <div v-for="(slide, k) in saleTopList" :key="k">
                    <v-card v-if="(k + 1) <= (i * 4) && Math.ceil((k+1) / 4) == i" max-width="100%" height="146" light tile class="d-flex align-center px-5 mb2" elevation="0" @click="navToGoodsDetail(slide.ssuList[0].ssuCode)">
                      <div><v-img :src="imageUrl+slide.skuImgMain" height="112px" width="112px" ></v-img></div>
                      <div style="margin-left: 15px;">
                        <div class="font-weight-bold shopName" style="margin-left: 9px;">
                          <template v-if="slide.ssuList.length > 1">
                            <b v-if="slide.hdActive" style="color: #B71210;">【活动】</b>
                          </template>
                          <template v-else>
                            <b v-if="slide.ssuList[0].eventMark === 10" style="color: #B71210;">【满送】</b>
                            <b v-if="slide.ssuList[0].eventMark === 20" style="color: #B71210;">【满赠】</b>
                            <b v-if="slide.ssuList[0].eventMark === 30" style="color: #B71210;">【满减】</b>
                            <b v-if="slide.ssuList[0].eventMark === 40" style="color: #B71210;">【折减】</b>
                            <b v-if="slide.ssuList[0].eventMark === 50" style="color: #B71210;">【特价】</b>
                          </template>
                          {{slide.ssuSkuName}}
                        </div>
                        <div class="tips"><span style="color:#E51C23;">{{slide.skuAlias}}</span>  {{ slide.skuSpecDescList.join('，') }}</div>
                        <div class="text-center d-flex zw"></div>
                        <div class="shopPrice">{{ slide.price }}</div>
                      </div>
                    </v-card>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </div>
        </div>
      </div>
      <!--精品推荐-->
      <div class="w12 mx-auto mt-5 ">
      <!--标题-->
        <div class="white d-flex align-center justify-center font-weight-bold headline mb-3" style="height: 68px;"><span class="red--text mr-4">·</span><span>推荐商品</span><span class="red--text ml-4">·</span></div>
        <goods-list :initData="parentList" id="reCom"/>
      </div>
      <!--回到顶部-->
      <div v-if="btnFlag" class="goTop d-flex align-center justify-center" @click="backTop()"><v-icon>mdi-arrow-collapse-up</v-icon></div>
    </v-content>
</template>

<script>
import goodsList from '../../components/goodsList'
import { queryCategoryList, bannerListQuery, findLoginMchInfo, quickEntryMain, queryAppPromotion, promotionSearchList, promotionNameSearch, topUpShelfProductList, topUpSaleProductList, productRecommendPageQuery } from '@/api/home'
import { getLoginData } from '../../utils/auth'
import { countTime } from '../../utils/time'

export default {
  name: 'home',
  components: { goodsList },
  data: () => ({
    // 图片地址前缀
    imageUrl: process.env.VUE_APP_IMAGE_URL,
    drawer: null,
    btnFlag: false,
    // banner
    bannerPhotos: [],
    item: 1,
    // 通栏广告
    advertisementList: [],
    // 商品分类 userTypeList
    userTypeList: [],
    userTypeChildrenList: [],
    // 用户信息
    userMessage: {
      userName: '未设定用户名',
      userImageUrl: ''
    },
    imageBealer: true,
    // 快捷入口
    kuaijie: [],
    // offset: true,
    // 促销活动（一个）
    oneList: [],
    oneEventList: [],
    oneEvent: false,
    // 促销活动（二个）
    twoList: [],
    twoEventList: [],
    twoEvent: false,
    // 促销活动（三个）
    threeList: [],
    threeEventList: [],
    threeEvent: false,
    // 促销商品
    oneEvnetId: [],
    twoEvnetId: [],
    threeEvnetId: [],
    evnetShop: {},
    twoTime: {},
    ssuSkuSpecDescList: undefined,
    promotionName: [],
    parseIntNum: 0,
    newTopList: [],
    parseTopNum: 0,
    saleTopList: [],
    nowTime: undefined,
    timer: null,
    parentList: [],
    isShow: true,
    num: 0,
    eventList: []
  }),
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
    // this.countTime()
    // 商品分类
    this.getQueryCategoryList()
    // banner
    this.getBannerList()
    // 获取用户信息
    this.getFindLoginMchInfo()
    // 快捷入口
    this.quickEntry_main()
    //  新品上架
    this.getTopUpShelfProductList()
    // 热销榜
    this.getTopUpSaleProductList()
    // 推荐商品
    this.getProductRecommendPageQuery()
    // 跳转到推荐
    if (this.$route.query.type === 1) {
      this.custormAnchor()
    }
  },
  created () {
    // 促销活动
    this.getQueryAppPromotion()
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
    clearInterval(this.timer)
  },
  methods: {
    getQueryCategoryList () {
      queryCategoryList().then(res => {
        if (res.data.success) {
          this.userTypeList = res.data.data.categoryVos
        }
      })
    },
    getBannerList () {
      let getLogin = getLoginData()
      getLogin = JSON.parse(getLogin)
      bannerListQuery({ siteId: getLogin.mchSiteId }).then(res => {
        if (res.data.success) {
          this.bannerPhotos = res.data.data.bannerList
          this.advertisementList = res.data.data.advertisementList
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    getFindLoginMchInfo () {
      findLoginMchInfo().then(res => {
        if (res.data.success) {
          if (res.data.data.mchImage !== null && res.data.data.mchImage !== 'defalutImg') {
            this.imageBealer = false
            this.userMessage.userImageUrl = this.imageUrl + res.data.data.mchImage
          }
          if (res.data.data.mchName !== null) {
            this.userMessage.userName = res.data.data.mchName
          }
        }
      })
    },
    quickEntry_main () {
      quickEntryMain().then(res => {
        if (res.data.success) {
          this.kuaijie = res.data.data.pageInfo
        }
      }).catch()
    },
    getQueryAppPromotion () {
      queryAppPromotion().then(res => {
        if (res.data.success) {
          this.eventList = res.data.data
          res.data.data.forEach(item => {
            if (item.eventEntityVOS.length === 1) {
              this.oneEvent = true
              this.oneList.push(...item.eventEntityVOS)
              this.oneList.forEach(list => {
                // 促销商品所需的id
                const oneEvnetId = []
                oneEvnetId.push(list.eventId)
                for (var i = 0; i < oneEvnetId.length; i++) {
                  if (this.oneEvnetId.indexOf(oneEvnetId[i]) === -1) {
                    this.oneEvnetId.push(oneEvnetId[i])
                  }
                }
              })
            }
            if (item.eventEntityVOS.length === 2) {
              this.twoEvent = true
              this.twoList.push(...item.eventEntityVOS)
              this.twoList.forEach(list => {
                // 促销商品所需的id
                const twoEvnetId = []
                twoEvnetId.push(list.eventId)
                for (var i = 0; i < twoEvnetId.length; i++) {
                  if (this.twoEvnetId.indexOf(twoEvnetId[i]) === -1) {
                    this.twoEvnetId.push(twoEvnetId[i])
                  }
                }
              })
              this.twoEventList.push(item.eventEntityVOS)
            }
            if (item.eventEntityVOS.length === 3) {
              this.threeEvent = true
              this.threeList.push(...item.eventEntityVOS)
              this.threeEventList.push(item.eventEntityVOS)
            }
          })
          this.timer = setInterval(() => {
            this.getActivityTime(this.oneList)
            this.getActivityTime(this.twoList)
            this.getActivityTime(this.threeList)
          }, 1000)
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
        this.oneEvnetId.forEach(i => {
          this.getPromotionSearchList({ promotionId: i, k: 1 })
          this.getpromotionNameSearch({ promotionId: i, k: 1 })
        })
        this.twoEvnetId.forEach(i => {
          this.getPromotionSearchList({ promotionId: i, k: 2 })
          this.getpromotionNameSearch({ promotionId: i, k: 2 })
        })
      }).catch(err => {
        console.log(err.message)
      })
    },
    getActivityTime (lists) {
      lists.forEach(list => {
        if (list.endTime !== null || list.startTime !== null) {
          const startTime = new Date(list.startTime.replace(/-/g, '/')).getTime()
          const endTime = new Date(list.endTime.replace(/-/g, '/')).getTime()
          const nowTime = new Date().getTime()
          this.nowTime = nowTime
          let endTi = 0
          if (endTime !== null) {
            if (nowTime < startTime) {
              endTi = startTime
              this.$set(list, 'times', countTime(endTi))
            } else {
              endTi = endTime
              this.$set(list, 'times', countTime(endTi))
            }
          }
        }
      })
    },
    // 获取促销商品
    getPromotionSearchList (item) {
      const prams = { pageNum: 1, pageSize: 1, ...item }
      promotionSearchList(prams).then(res => {
        if (res.data.success) {
          const list = res.data.data.pageInfo.list
          // 促销活动有时候商品为空
          if (res.data.data.pageInfo.list.length > 0) {
            this.evnetShop = list[0]
          } else {
            this.isShow = false
            return
          }
          this.$set(this.evnetShop, 'items', item)
          if (this.evnetShop.items.k === 1) {
            const skuSpecDescList = this.evnetShop.skuSpecDescList
            const num = this.evnetShop.ssuList.length
            const minPrice = this.evnetShop.ssuList[0].ssuSellingPrice.standardString
            const maxPrice = this.evnetShop.ssuList[num - 1].ssuSellingPrice.standardString
            let price = ''
            if (minPrice === maxPrice) {
              price = minPrice
            } else {
              price = minPrice + '~' + maxPrice
            }
            const oneShopList = {
              price: price,
              ssuCode: this.evnetShop.ssuList[0].ssuCode,
              shopName: this.evnetShop.ssuList[0].ssuName,
              imgUrl: this.evnetShop.skuImgMain,
              skuSpecDescList: skuSpecDescList,
              ...item
            }
            this.oneList.forEach(i => {
              if (oneShopList.promotionId === i.eventId) {
                this.$set(i, 'oneShopList', oneShopList)
              }
            })
          }
          if (this.evnetShop.items.k === 2) {
            const skuSpecDescList = this.evnetShop.skuSpecDescList
            const num = this.evnetShop.ssuList.length
            const minPrice = this.evnetShop.ssuList[0].ssuSellingPrice.standardString
            const maxPrice = this.evnetShop.ssuList[num - 1].ssuSellingPrice.standardString
            let price = ''
            if (minPrice === maxPrice) {
              price = minPrice
            } else {
              price = minPrice + '~' + maxPrice
            }
            const twoShopList = {
              price: price,
              ssuCode: this.evnetShop.ssuList[0].ssuCode,
              shopName: this.evnetShop.ssuList[0].ssuName,
              imgUrl: this.evnetShop.skuImgMain,
              skuSpecDescList: skuSpecDescList,
              ...item
            }
            this.twoEventList.forEach(i => {
              i.forEach(tu => {
                if (twoShopList.promotionId === tu.eventId) {
                  this.$set(tu, 'twoShopList', twoShopList)
                }
              })
            })
          }
          this.evnetShop = {}
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 获取促销方式
    getpromotionNameSearch (item) {
      const prams = { promotionId: item.promotionId }
      promotionNameSearch(prams).then(res => {
        if (res.data.success) {
          const promotionList = res.data.data
          this.$set(promotionList, 'items', item)
          let voList = []
          if (promotionList.promotionSsuCodeVoList.length > 2) {
            promotionList.promotionSsuCodeVoList.forEach(icon => {
              if (voList.length < 2) { voList.push(icon) }
            })
          } else {
            voList = promotionList.promotionSsuCodeVoList
          }
          const oneShopNameList = {
            ...item,
            promotionNameList: voList
          }
          this.oneList.forEach(i => {
            if (oneShopNameList.promotionId === i.eventId) {
              this.$set(i, 'oneShopNameList', oneShopNameList.promotionNameList)
            }
          })
          this.twoEventList.forEach(i => {
            i.forEach(tu => {
              if (oneShopNameList.promotionId === tu.eventId) {
                this.$set(tu, 'twoShopNameList', oneShopNameList.promotionNameList)
              }
            })
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 新品上架
    getTopUpShelfProductList () {
      topUpShelfProductList({ pageNum: 1, pageSize: 12 }).then(res => {
        if (res.data.success) {
          const list = res.data.data.pageInfo.list
          const lengthNum = list.length
          this.parseIntNum = Math.ceil(lengthNum / 4)
          // 获取商品
          list.forEach(item => {
            const num = item.ssuList.length
            if (item.ssuList.length > 1) {
              item.ssuList.forEach(obj => {
                if (obj.eventMark) item.hdActive = true
              })
            }
            const minPrice = item.ssuList[0].ssuSellingPrice.standardString
            const maxPrice = item.ssuList[num - 1].ssuSellingPrice.standardString
            let price = ''
            if (minPrice === maxPrice) {
              price = '￥' + minPrice
            } else {
              price = '￥' + minPrice + '~￥' + maxPrice
            }
            this.$set(item, 'price', price)
            this.newTopList.push(item)
          })
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 热销榜
    getTopUpSaleProductList () {
      topUpSaleProductList({ pageNum: 1, pageSize: 12 }).then(res => {
        if (res.data.success) {
          const list = res.data.data.pageInfo.list
          const lengthNum = list.length
          this.parseTopNum = Math.ceil(lengthNum / 4)
          // 获取商品
          list.forEach(item => {
            const num = item.ssuList.length
            if (item.ssuList.length > 1) {
              item.ssuList.forEach(obj => {
                if (obj.eventMark) item.hdActive = true
              })
            }
            const minPrice = item.ssuList[0].ssuSellingPrice.standardString
            const maxPrice = item.ssuList[num - 1].ssuSellingPrice.standardString
            let price = ''
            if (minPrice === maxPrice) {
              price = '￥' + minPrice
            } else {
              price = '￥' + minPrice + '~￥' + maxPrice
            }
            this.$set(item, 'price', price)
            this.saleTopList.push(item)
          })
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 推荐商品
    getProductRecommendPageQuery (data) {
      productRecommendPageQuery({ pageSize: 20 }).then(res => {
        if (res.data.success) {
          const list = res.data.data.pageInfo.list
          this.parentList = list
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 返回顶部
    backTop () {
      const that = this
      const timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    // 通栏广告跳转
    toList (id) {
      this.bannerPhotos.forEach(pro => {
        if (pro.id === id) {
          if (pro.bannerLinkType === 'LINKSINGLE') {
            this.navToGoodsDetail(pro.ssuCode)
          } else if (pro.bannerLinkType === 'LINKMUITI') {
            const name = pro.bannerName
            this.getBannerProductListQuery(id, name)
          }
        }
      })
      this.advertisementList.forEach(item => {
        if (item.id === id) {
          if (item.bannerLinkType === 'LINKSINGLE') {
            this.navToGoodsDetail(item.ssuCode)
          } else if (item.bannerLinkType === 'LINKMUITI') {
            const name = item.bannerName
            this.getBannerProductListQuery(id, name)
          }
        }
      })
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      if (this.scrollTop > 60) {
        this.btnFlag = true
      } else {
        this.btnFlag = false
      }
    },
    //  跳转页面
    // 商品详情页
    navToGoodsDetail (it) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          ssuCode: it,
          name: name
        }
      })
    },
    // 全部分类
    goList (it) {
      this.$router.push({
        path: '/goodsAllFl',
        query: {
          pid: it.parentId,
          tid: it.id
        }
      })
    },
    // 常购清单
    pageToCg () {
      this.$router.push({
        path: '/CheckList'
      })
    },
    // 新品上架/热销榜
    viewMorenew () {
      this.$router.push({
        path: '/viewMorenew'
      })
    },
    viewMoretop () {
      this.$router.push({
        path: '/viewMoretop'
      })
    },
    // 首页
    logoToHome () {
      this.$router.push({
        path: '/',
        query: {
          t: new Date().getTime()
        }
      })
    },
    //  跳转活动页面
    pageToPromotion (eventId) {
      this.$router.push({
        path: '/promotion',
        query: {
          promotionId: eventId
        }
      })
    },
    // 跳转个人中心
    personalCenter () {
      this.$router.push({
        path: '/personalCenter'
      })
    },
    // 跳转快捷入口 /access
    goAccess (it) {
      this.$router.push({
        path: '/access',
        query: {
          firstEntryName: it.firstEntryName,
          parentId: it.entryId
        }
      })
    },
    //  通栏广告关联多个单品页
    getBannerProductListQuery (id, name) {
      this.$router.push({
        path: '/machShop',
        query: {
          id: id,
          name: name
        }
      })
    },
    getImg (e) {
      this.bigsrc = e
    },
    getSpecification (e) {
      this.spec = e
    },
    numadd () {
      this.numval++
    },
    nummin () {
      this.numval--
    },
    custormAnchor () {
      // 找到锚点
      const anchorElement = document.getElementById('reCom')
      setTimeout(() => {
        if (anchorElement) {
          const total = anchorElement.offsetTop + 10// 定位锚点
          // 开始滚动
          // Chrome
          document.body.scrollTop = total
          // Firefox
          document.documentElement.scrollTop = total
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .home{ font-family: "Microsoft YaHei UI"; background: #F2F2F2; position: relative;}
  /* 底部距离2px*/
  .mb2{margin-bottom: 2px;}
/* 改变背景颜色 */
  .spacing-playground .v-select .v-input__prepend-outer, .spacing-playground .v-select .v-input__append-outer{margin-top: 0.55rem;margin-right: 0.2rem;}
  .flo{float: left;}
  .lb{width: 89%;}
  .cp{cursor: pointer;}
  .search{border: 1px solid #E64545;width: 355px;height: 36px;border-radius: 5px;overflow: hidden;}
  .searchBox{width: 275px;height: 36px;float: left;padding-left: 15px;}
  .container{padding: 0;}
  .xian{ width: 100%;position: absolute;left: 0; bottom: 0;}
  .v-content__wrap{ background-color: #eeeeee !important;}
/*  标题  */
  .title{ height:48px;width:100%; margin-top: 2px;}
  .titleBox{ height: 100%;width: 1200px;cursor: pointer;}
  .titleType{ width:200px;height:100%;line-height:48px;border-radius: 10px 10px 0 0;}
  .titleHome{ width:97px;height:100%;line-height:48px;}
  .titleList{ height:100%;line-height:48px;}
  .bannerRightCard{ box-shadow:0px 2px 12px 0px rgba(254,220,223,1);}
/* 菜单/轮播/个人信息 */
  .w12{width:1200px;}
  .bannerLeft{width:200px; height:500px;}
  .bannerRight{width:250px;background: url("../../assets/img/beijing.png");background-repeat: no-repeat;background-size: 100%;background-position: center;}
  .typeList{max-width:750px;max-height:500px;min-width: 375px;}
/*  快捷入口*/
  .quickAccess{width: 1200px;}
/*  促销活动（一个）*/
  .oneAccess{position: relative;}
  .accessTtile{ width:100%;height: 68px;}
  .accessCont{ width: 100%;height: 300px;}
  .accessContLeft{ width: 900px;height: 100%;padding-bottom: 17px;}
  .accessContRight{ width: 300px;height: 100%;padding: 17px 19px;}
  .shopName{font-size:16px;margin-bottom: 5px;}
  .tips{font-size:13px;font-weight:400;color: #666666;margin-bottom: 5px;margin-left: 9px;}
  .zw{height:19px;}
  .accessBorder{min-width:73px;height:19px;border:1px solid rgba(229,28,35,1);border-radius:4px;font-size:14px;font-weight:400;color: #E51C23;margin-left: 9px;line-height: 19px;margin-bottom: 8px; padding: 0 4px;}
  .shopPrice{color: #E51C23;margin-left: 9px;font-size: 21px}
  .smallSize{font-size: 13px;}
/*  促销活动（二个）*/
  .accessTwo{width:1200px; height: 490px;}
  .accessBox{width: 590px; padding: 26px 20px 0;cursor: pointer;position: relative;}
  .accessTwoTitle{margin-bottom: 14px;}
/*  促销活动（二个）*/
  .accessThree{width:1200px; height: 433px;}
  .accessThreeTitle{width: 385px;padding: 23px 20px;cursor: pointer;}
/*  分隔符*/
  ::v-deep .v-carousel__controls{height: 14px;}
  ::v-deep .redLeft {.v-btn--icon.v-size--small .v-icon{font-size: 12px!important;color: #F44336}}
  ::v-deep .blueRight {.v-btn--icon.v-size--small .v-icon{font-size: 12px!important;color: #2196F3}}
/*  回到顶部*/
  .goTop{cursor: pointer; position: fixed; z-index: 99; bottom:60px; left: calc(50% + 616px); width:56px;height:56px;background:rgba(228,4,4,0.1); border-radius:50%; .v-icon{color: #E40404;}}
/*  倒计时*/
  .timing {height: 32px;line-height: 32px;padding: 0 15px;text-align: right;}
  .titixt {color: #fff;background-color: #f10000;border-radius: 4px;padding: 1px 4px;margin-left: 3px;}
  .shopImg{width: 340px;height: 340px; position: relative;}
  .over{width: 340px;height: 340px;position: absolute;top: 0;left: 0;z-index:2;background:rgba(120,2,2,.4);}
  .overImg{margin-top: 128px;margin-left:96px;}
  .twoOver{width: 590px;height: 490px;position: absolute;top: 0;left: 0;z-index:2;background:rgba(120,2,2,.4);}
  .twoOverImg{margin-left: 221px;margin-top: 203px;}
  .oneOver{width: 1200px;height: 368px;background:rgba(120,2,2,.4);position: absolute;top: 0;left: 0;z-index: 2;}
  .oneOverImg{margin-top: 142px;margin-left: 528px;}
  .ml9{margin-left: 9px;}
</style>
